'use strict';

const renderShippingCalculator = require('./shippingCalculator').renderShippingCalculator;
import { executeScriptsFromHTML } from 'app_custom_mufe_revamp/utilities/utils';

const miniCart = {
    elements: {
        $miniCartWrapper: $('.js-mini-cart'),
        $body: $('body')
    },

    selectors: {
        cartContent: '.js-mini-cart-content',
        miniCartDialog: '#mini-cart-modal',
        cartDialog: '#cart-modal',
        emptyCart: '.js-empty-cart',
        viewBagButton: '.js-view-bag',
        productWrapper: '.js-mini-cart-product',
        squirrellyProducts: '#mini-product-card',
        renderMiniCartRecommendations: '.js-mini-cart-recommendations'
    },

    state: {
        cartGetUrl: null,
        updateQtyUrl: null,
        lastAddedItems: [],
        cartMiniCartRecommendationsUrl: null
    },

    init() {
        this.state.cartGetUrl = this.elements.$miniCartWrapper.attr('data-cart-get-url');
        this.state.cartMiniCartRecommendationsUrl = this.elements.$miniCartWrapper.attr('data-cart-minicartrecommendations-url');

        this.initEvent();
    },

    initEvent() {
        this.elements.$miniCartWrapper.on('minicart-update', this.onMiniCartUpdate.bind(this));
        $(this.selectors.miniCartDialog).on('click',this.selectors.viewBagButton, this.openCartDialog.bind(this));
    },

    //call this function each time dynamic component of the cart need to be updated (must be called by an event)
    onMiniCartUpdate(_, { cart, isMiniCartOpen}){
        const isEmpty = cart.numItems === 0;

        $(this.selectors.emptyCart).attr('hidden', !isEmpty);
        $(this.selectors.cartContent).attr('hidden', isEmpty);

        this.state.lastAddedItems = isMiniCartOpen ? [...this.state.lastAddedItems, ...cart.lastAddedItem] : cart.lastAddedItem;

        $(this.selectors.productWrapper).morphBy({
            id: this.selectors.squirrellyProducts,
            squirrellyOptions: {
                product: this.state.lastAddedItems
            },
            morphDomOptions: {
                morph: true,
                childrenOnly: true
            }
        })

        renderShippingCalculator(cart, $(this.selectors.miniCartDialog));
        this.renderMiniCartRecommendations();
    },

    openCartDialog() {
        if ($(this.selectors.miniCartDialog).hasClass('sf-mini-cart')) {
            $(this.selectors.miniCartDialog).removeClass('sf-mini-cart');
        }
        $(this.selectors.miniCartDialog).dialog({open: false});
        $(this.selectors.cartDialog).dialog({open: true});
    },

    renderMiniCartRecommendations() {
        $.ajax({
            url: this.state.cartMiniCartRecommendationsUrl,
            method: 'GET',
            success: (data) => {
                const cleanedHTML = executeScriptsFromHTML(data);
                $(this.selectors.renderMiniCartRecommendations).html(cleanedHTML);
            }
        });
    }
};

miniCart.init();